import React from "react";
import { useTranslation } from "react-i18next";
import Loader from "react-js-loader";

const SubmitButton = ({
  id,
  isSubmitting,
  disabled,
  click,
  text,
  className,
  isLoading,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <button
        id={id}
        className={className}
        type="submit"
        disabled={isSubmitting || disabled}
        onClick={click}
      >
        {isLoading ? (
          <Loader
            type="bubble-scale"
            bgColor={"#ffffff"}
            color={" #00A0DF "}
            size={25}
          />
        ) : (
          <>{t(text)}</>
        )}
      </button>
    </>
  );
};

export default SubmitButton;
